import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'profilePassword' })
export class ProfilePasswordPipe implements PipeTransform {
  transform(password: string): string {
    return '•'.repeat(password.length);
  }
}
